import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { AuthService } from './auth-service';

export const authCanActivateChildGuard: CanActivateChildFn = (childRoute, state) => {
  return inject(AuthService).isAuthenicated();
};
